<template>
  <div>
    <Hero />
    <Why />
    <FeaturedMovies />
    <FeaturedTVShows />
    <BlogSection />
    <CityDorms />
    <Media />
    <!--<FixedPopup />-->
  </div>
</template>

<script>
import Hero from '@/components/Home/Hero.vue'
import Why from '@/components/Home/Why.vue'
import BlogSection from '@/components/Home/BlogSection.vue'
import FeaturedMovies from '@/components/Home/FeaturedMovies.vue'
import FeaturedTVShows from '@/components/Home/FeaturedTVShows.vue'
import CityDorms from '@/components/Home/CityDorms.vue'
import Media from '@/components/Home/Media.vue'
import { mapGetters } from 'vuex'
import {
  SET_PRELOADER
} from '@/store/mutations.type'

export default {
  name: 'Home',
  components: {
    Hero, Why, BlogSection, FeaturedMovies, FeaturedTVShows, CityDorms, Media
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.settings ? this.settings.setting.title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.settings ? this.settings.setting.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.settings ? this.settings.setting.keywords : '' }
      ],
       link: [
        { rel: 'canonical', href: 'https://www.holywoodskyline.com' },
        { rel: 'favicon', href: 'favicon.ico' }
      ]      
    }
  },
  computed: {
    ...mapGetters(['pageClass', 'showPreloader', 'showMenu', 'settings'])
  }
}
</script>

<style lang="scss">

</style>
